<!--Prototype of contact-us page for main washoetribe site (will probs need diff one for departments-->

<template>
  <main class="pad">
    <div v-if="!loading">

    <!--Parralax image with page title and optional sub-heading-->

      <PageHeader
        v-if="page.meta.parent.meta.type == 'departments.DepartmentLandingPage'"
        :title="page.title"
        :logo_url="page.logo ? page.logo.meta.download_url : page.get_department_logo_url"
        :image_url="page.image ? page.image.meta.download_url : page.get_department_image_url"
        :subtitle="page.subtitle ? page.subtitle : ''"
        :dept_link="'/departmentlandingpage/'+parentSlug"
      >
      </PageHeader>

      <PageHeader
        v-else
        :title="page.title"
        :logo_url="page.logo ? page.logo.meta.download_url : page.get_homepage_logo_url"
        :image_url="page.image ? page.image.meta.download_url : page.get_homepage_image_url"
        :subtitle="page.subtitle ? page.subtitle : ''"
      >
      </PageHeader>

      <!--Tabs showing tribe contact locations, card showing information and map-->

      <mdb-container v-if="!loading">
        <mdb-row class="my-3">
          <mdb-col>
            <ContactTab 
              
              :contact_info="contact_info">
            </ContactTab>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>
  </main>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol
} from "mdbvue"
import axios from "axios";
import api from "@/api"
import shared from "@/shared";
import PageHeader from "@/views/PageHeader.vue";
import ContactTab from "@/views/contact/ContactTab.vue";
export default {
  name: "Contact",
  components: {
    mdbContainer, 
    mdbRow,
    mdbCol,
    PageHeader,
    ContactTab
  },
  props: {
    slug: String
  },
    data() {
    return {
      page: String,
      loading: true,
      parentSlug: String
    };
  },
  mounted() {
    axios
      api.get("pages/" + this.slug)
      .then(response => {
        this.page = response.data;
        this.contact_info = this.page.contact_information;
        shared.getDepartmentSkinFromPage(response.data);
        this.parentSlug = shared.extractParentSlug(this.page.meta.parent.meta.html_url)
      })
      .catch(e => {
        this.errors.push(e);
      })
      .finally(() => (this.loading = false));
  },
}
</script>